import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "budget-add hmd-btn" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增施工预算工程量")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 保存并关闭 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 保存并继续 ")

export function render(_ctx, _cache) {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.visible=true))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[10] || (_cache[10] = $event => ((_ctx.visible) = $event)),
      centered: true,
      keyboard: false,
      "mask-closable": false,
      title: "新增施工预算工程量",
      width: "534px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.submit(0)))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.submit(1)))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.formModel,
          rules: _ctx.formRules,
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, _mergeProps({ label: "清单编号：" }, _ctx.validateInfos.bizNo), {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formModel.bizNo,
                  "onUpdate:value": _cache[3] || (_cache[3] = $event => ((_ctx.formModel.bizNo) = $event)),
                  placeholder: "请输入",
                  style: {"width":"360px"},
                  maxlength: 50
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({ label: "清单名称：" }, _ctx.validateInfos.name), {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formModel.name,
                  "onUpdate:value": _cache[4] || (_cache[4] = $event => ((_ctx.formModel.name) = $event)),
                  placeholder: "请输入",
                  style: {"width":"360px"},
                  maxlength: 150
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({ label: "项目特征：" }, _ctx.validateInfos.feature), {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.formModel.feature,
                  "onUpdate:value": _cache[5] || (_cache[5] = $event => ((_ctx.formModel.feature) = $event)),
                  placeholder: "请输入",
                  style: {"width":"360px"},
                  maxlength: 500
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({ label: "结算单位：" }, _ctx.validateInfos.unit), {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formModel.unit,
                  "onUpdate:value": _cache[6] || (_cache[6] = $event => ((_ctx.formModel.unit) = $event)),
                  placeholder: "请输入",
                  style: {"width":"360px"},
                  maxlength: 10
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({ label: "工程量：" }, _ctx.validateInfos.budgetCount), {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: _ctx.formModel.budgetCount,
                  "onUpdate:value": _cache[7] || (_cache[7] = $event => ((_ctx.formModel.budgetCount) = $event)),
                  placeholder: "请输入",
                  style: {"width":"360px"},
                  precision: 4,
                  maxLength: 8
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({ label: "综合单价：" }, _ctx.validateInfos.budgetPrice), {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: _ctx.formModel.budgetPrice,
                  "onUpdate:value": _cache[8] || (_cache[8] = $event => ((_ctx.formModel.budgetPrice) = $event)),
                  placeholder: "请输入",
                  style: {"width":"360px"},
                  precision: 4,
                  maxLength: "12"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({ label: "合价(￥)：" }, _ctx.validateInfos.budgetTotalPrice), {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.budgetTotalPrice) + "元", 1)
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({ label: "备注：" }, _ctx.validateInfos.remark), {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.formModel.remark,
                  "onUpdate:value": _cache[9] || (_cache[9] = $event => ((_ctx.formModel.remark) = $event)),
                  placeholder: "请输入备注",
                  style: {"width":"360px"},
                  maxlength: 100
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }, 8, ["model", "rules", "label-col", "wrapper-col"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}